import { Component, OnInit, OnDestroy } from '@angular/core';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPFeaturePackageUserManagementService } from '../../../src/app/user/ph-bhp-feature-package-user-management.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-trial-license-warning',
  templateUrl: './trial-license-warning.component.html',
  styleUrls: ['./trial-license-warning.component.css']
})
export class TrialLicenseWarningComponent implements OnInit, OnDestroy {
  showWarning = false;
  institutionType: string = '';
  institutionSubscription: Subscription;
  institutionID = 0;

  constructor(
    private layoutService: PHBHPLayoutPackageService,
    private institutionService: PHBHPFeaturePackageUserManagementService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.institutionID = +localStorage.getItem('selectedInstitution');
    // Revisar si hay valor guardado en localStorage para la institución actual
    const localStorageKey = `sshowLicenseWarning`;
    const storedWarning = localStorage.getItem(localStorageKey);
    if (storedWarning !== null) {
      this.showWarning = storedWarning === 'true';
    } else {
      this.checkInstitutionType();
    }
    this.institutionSubscription = this.layoutService.institutionIDSubject.asObservable().subscribe((res) => {
      this.institutionID = res;
      const newKey = `showLicenseWarning`;
      localStorage.removeItem(newKey);
      this.checkInstitutionType();
    });
  }

  ngOnDestroy() {
    if (this.institutionSubscription) this.institutionSubscription.unsubscribe();
  }

  checkInstitutionType() {
    if (!this.institutionID) {
      this.showWarning = false;
      return;
    }
    const localStorageKey = `showLicenseWarning`;
    this.institutionService.getInstitutionById(this.institutionID).subscribe((res: any) => {
      this.institutionType = res[0].institution.institutionType;
      this.showWarning = this.institutionType === 'TRIAL';
      // Guardar el resultado en localStorage
      localStorage.setItem(localStorageKey, this.showWarning.toString());
    }, () => {
      this.showWarning = false;
      // Si hay error, limpiar el parámetro de localStorage
      localStorage.removeItem(localStorageKey);
    });
  }
}
